// ADR-199: Reports → Integrity Checks — live results of radar-api's read-only
// integrity checks (ADR-153 step B). Both routes require read EmploymentChangeRecord.
export const INTEGRITY_CHECKS_PATH = '/reports/integrity-checks';

export const INTEGRITY_SCOPES = Object.freeze({
  EMPLOYMENT: 'employment',
  ORG_EDGES: 'org-edges',
});

export const INTEGRITY_SCOPE_LABELS = {
  employment: 'Employment & contracts',
  'org-edges': 'Organization history',
};

export const INTEGRITY_SCOPE_DESCRIPTIONS = {
  employment: 'Contract and employment-period rules the application enforces and the database does not: open-contract limits, sync ownership, the primary contract, pending terminations, overlaps and position history.',
  'org-edges': 'Manager history checked against the organization structure history: duplicate or overlapping periods, missing open rows and drift.',
};

/** Rows shown per check; radar-api returns at most this many samples. */
export const INTEGRITY_SAMPLE_LIMIT = 20;

/** How a check reads at a glance. */
export const CHECK_STATUSES = Object.freeze({
  VIOLATIONS: 'VIOLATIONS',
  INFO_ONLY: 'INFO_ONLY',
  PASSED: 'PASSED',
});

export const CHECK_STATUS_COLORS = {
  VIOLATIONS: 'error',
  INFO_ONLY: 'info',
  PASSED: 'success',
};
